import React from "react";
import { useTranslation } from "react-i18next";
import Box from "../../../../common/box/Box";

function RequiredDocumentInfoItem({ label, link }) {
  const { t } = useTranslation();

  return (
    <Box>
      <div className="level ">
        <div className="level-left level-item is-flex-shrink-1">{label}</div>
        <div className="level-right level-item">
          <a
            target="_blank"
            href={link}
            rel="noopener noreferrer"
            className="button is-pulled-left"
          >
            {t("requests.submission.info.more")}
          </a>
        </div>
      </div>
    </Box>
  );
}

export default RequiredDocumentInfoItem;
